import React from "react";
import CommonAlert from "../../../../shared/components/generic/alert/common-alert/common-alert";

export default function SimulationErrorAlerts({
	simulationError,
	financialInstallmentsError,
	indicatedConditionsError,
	simulationCreateError,
	simulationUpdateError
}) {
	return (
		<>
			<CommonAlert
				message={simulationError}
				fallbackMessage="Não foi possível carregar a simulação."
			/>

			<CommonAlert
				message={financialInstallmentsError}
				fallbackMessage="Não foi possível carregar as parcelas disponíveis."
			/>

			<CommonAlert
				message={indicatedConditionsError}
				fallbackMessage="Não foi possível carregar as condições de pagamento."
			/>

			<CommonAlert
				message={simulationCreateError}
				fallbackMessage="Não foi possível calcular a simulação."
			/>

			<CommonAlert
				message={simulationUpdateError}
				fallbackMessage="Não foi possível recalcular a simulação."
			/>
		</>
	);
}